<template>
    <Button :label="$t('assign_to_driver')" icon="pi pi-plus" class="p-button-primary p-button-sm mr-1" @click="onShowAssignModal" />

    <CustomSidebar v-model:visible="showAssignModal" position="bottom" :dismissable="false" :title="$t('assign_to_driver')" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-save" class="p-button p-button-success mr-1" :label="$t('assign_to_driver')" @click="save()"></Button>
        </template>

        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <ScrollPanel style="width:100%;height:80vh">
                    <ModalData :data="orderData" v-if="orderData"/>
                </ScrollPanel>
            </div>
            
            <Divider layout="vertical" />

            <div class="col-8 md-4 p-fluid">
                <ScrollPanel style="width:100%;height:80vh">
                    <FormField :labelName="$t('add_to_shipment')" fieldName="Add_To_Shipment" v-model="orderData" fieldClass="col-4" labelClass="col-3" v-if="!isCollective">
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">
                                <Checkbox v-model="addToShipment" :binary="true" />
                            </span>
                            <InputText name="Add_To_Shipment_No" type="text" disabled v-model="addToShipmentNo"/>
                            <Button icon="pi pi-ellipsis-h" class="p-button p-button-sm" :disabled="!addToShipment" @click="onShowAvailableShipmentsModal"/>
                        </div>
                    </FormField>

                    <DataTable :loading="!orderData" :value="orderData ? orderData.Details : null" class="p-datatable-sm editable-cells-table">
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No" class="w-1">  
                        </Column>
                        <Column field="Material_Name" header="Material" key="Material_Name">
                        </Column>
                        <Column field="Qty" :header="$t('qty')" v-if="addToShipment" class="w-1">
                            <template #body="slotProps">
                                <InputNumber name="Qty" mode="decimal" :optionalDecimal="true" v-model="slotProps.data.Qty" :max="slotProps.data.os_qty" />
                            </template>
                        </Column>
                        <Column field="os_qty" :header="$t('os_qty')" key="Active" class="w-1">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="sto_qty" :header="$t('sto_qty')">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                    </DataTable>

                    <Divider />

                    <div v-if="addToShipment">
                        <FormField :labelName="$t('driver')" fieldName="Driver" v-model="orderData" fieldClass="col-6" labelClass="col-3">
                            <InputText name="Driver" type="text" disabled v-model="addToShipmentDriverName"/>
                        </FormField>
                        <FormField :labelName="$t('license_no')" fieldName="License_No" v-model="orderData" fieldClass="col-6" labelClass="col-3">
                            <InputText name="License_No" type="text" disabled v-model="addToShipmentLicenseNo"/>
                        </FormField>
                        <FormField :labelName="$t('truck')" fieldName="Vehicle" v-model="orderData" fieldClass="col-6" labelClass="col-3">
                            <InputText name="Vehicle" type="text" disabled v-model="addToShipmentVehicleNo"/>
                        </FormField>
                    </div>
                    <div v-else>
                        <AssignEditDriver 
                            v-if="orderData"
                            :materials="orderData ? orderData.Details : []" 
                            :transporterCode="transporter" 
                            :locationCode="location" 
                            :isIndividual="isIndividual" 
                            :isCollective="isCollective" 
                            :isRelation="isRelation" 
                            :dataModel="assignEditDriverModel"
                            :isAssign="true"
                            :assignMultiple="true"
                            :useLN="useLN"
                            :warehouseCode="warehouseCode"
                            :multipleWeighing="multipleWeighing"
                            :disableEditQtyIndividualTruck="disableEditQtyIndividualTruck"
                            />
                    </div>
                </ScrollPanel>
                
            </div>
        </div>
    </CustomSidebar>    

    <Dialog v-model:visible="showAvailableShipmentsModal" header="Select Shipment" :draggable="false" :modal="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" style="width:75vw">
        <DataTable 
            :loading="availableShipmentsLoading" 
            @row-dblclick="onAvailableShipmentSelect" 
            :value="availableShipmentsList" 
            responsiveLayout="scroll" 
            class="p-datatable-sm editable-cells-table"
            :rowClass="selectedShipment"
            >
            <template #empty>
                No records found
            </template>
            <Column field="Shipment_No" :header="$t('shipment_no')" key="Shipment_No">  
            </Column>
            <Column field="Order_No" :header="$t('order_no')" key="Order_No">
            </Column>
            <Column field="SAP_No" :header="$t('sap_no')" key="SAP_No">
            </Column>
            <Column field="Driver_Name" :header="$t('driver')" key="Driver_Name">
            </Column>
            <Column field="Vehicle_Name" :header="$t('truck')" key="Vehicle_Name">
            </Column>
            <Column field="Product_Category" :header="$t('product_category')" key="Product_Category">
            </Column>
            <Column field="Status" header="Status" key="Status">
            </Column>
            <Column field="Appointment_Date" :header="$t('appointment_date')" key="Appointment_Date">
                <template #body="slotProps">
                    {{$formatDate(slotProps.data.Appointment_Date)}}
                </template>
            </Column>
            <Column field="Appointment_Time" :header="$t('appointment_time')" key="Appointment_Time">
            </Column>
            <Column field="Appointment_Status" :header="$t('appointment_status')" key="Appointment_Status">
            </Column>
        </DataTable>
    </Dialog>
</template>
<script>
    import ModalData from '../Helper/_ModalData.vue'
    import AssignEditDriver from '../Helper/_AssignEditDriver.vue'

    export default{
        components: {
            'ModalData': ModalData,
            'AssignEditDriver': AssignEditDriver
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            },
        },
        data(){
            return{
                showAssignModal: false,
                isIndividual: false,
                isCollective: false,
                isRelation: false,
                driverModels: [],
                orderData: null,
                driverModel: null,
                dataUrl: "order/",
                blocked:false,
                transporter:"",
                location: "",

                addToShipment: false,
                addToShipmentNo: "",
                addToShipmentDriverName: "",
                addToShipmentLicenseNo: "",
                addToShipmentVehicleNo: "",
                showAvailableShipmentsModal: false,
                availableShipmentsList: [],
                availableShipmentsLoading: false,
                expandedRows: [],
                useLN: false,
                warehouseCode: "",
                disableEditQtyIndividualTruck: true,

                multipleWeighing: false,
            }
        },
        mounted(){
            // if(self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL)
            //     this.addDetail();
        },
        methods:{
            reset(){
                this.orderData = null;
                this.driverModel = null;
                this.driverTruckModel = null;
                this.driverModels = [];
                this.isRelation = false;
                this.isIndividual = false;
                this.isCollective = false;
                this.transporter = "";
                this.location = "";

                this.addToShipment = false;
                this.addToShipmentNo = "";
                this.addToShipmentDriverName = "";
                this.addToShipmentVehicleNo = "";
                this.addToShipmentLicenseNo = "";
                this.useLN = false;

                this.warehouseCode = "";
            },
            onShowAssignModal(){
                this.reset();
            
                this.blocked = true;
                this.showAssignModal = true;

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.data[0].Id + "/" + this.$FORM_MODE_EDIT)
                    .then((response) => {
                        if (response.data.success) {
                            self.orderData = response.data.data.header;
                            self.driverModel = response.data.data.assign_driver;

                            self.multipleWeighing = self.orderData.Multiple_Weighing =="Y";

                            // if(self.orderData.Shipment_Type_Category == this.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL)
                            //     this.addDetail();

                            self.isRelation = self.orderData.is_relation;
                            self.isIndividual = self.orderData.shipment_type_category == self.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL;
                            self.isCollective = self.orderData.shipment_type_category == self.$SHIPMENT_TYPE_CATEGORY.COLLECTIVE;
                            self.transporter = self.orderData.Transporter_Code;
                            self.location = self.orderData.warehouse_location;
                            self.warehouseCode = self.orderData.Warehouse_Code;

                            self.useLN = response.data.data.header.use_ln;
                            self.disableEditQtyIndividualTruck = response.data.data.header.disable_edit_qty_individual_truck;

                            //self.$refs.assignEditDriver.initModel();
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    }); 
            },
            save(){
                var self = this;

                if(this.addToShipment){
                    if(!this.addToShipmentNo){
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: self.$t('alert.require_shipment_no'), life: 120000});
                        return;
                    }

                    var assignData = {
                        order_id: this.orderData.Id,
                        shipment_no : this.addToShipmentNo,
                        materials: this.orderData.Details
                    };

                    this.blocked = true;
                    this.$axios.post(this.$API_URL + this.dataUrl + "add_to_shipment", assignData)
                        .then((response) => {
                            if (response.data.success) {
                                self.showAssignModal = false;
                                self.$parent.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                                self.$emit('close');
                            }
                            else {
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            }

                            self.blocked = false;
                        })
                        .catch(function(err) {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                            self.blocked = false;
                        });

                }
                else{
                    var data = {
                        order_id: this.orderData.Id,
                        drivers: this.driverModels
                    };

                    for(var x = 0; x< this.driverModels.length;x++){
                        var materials = this.driverModels[x].materials;
                        var driver = this.driverModels[x];

                        if(this.isRelation){
                            if(!driver.Driver_Name){
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: `Item ${x+1}: ` + self.$t('alert.require_driver_assign_driver'), life: 120000});
                                return;
                            }

                            if(!driver.Vehicle_Name){
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: `Item ${x+1}: ` + self.$t('alert.require_vehicle_assign_driver'), life: 120000});
                                return;
                            }

                            if(!driver.License_No){
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: `Item ${x+1}: ` + self.$t('alert.require_license_no'), life: 120000});
                                return;
                            }
                        }
                        else{ 
                            if(driver.Driver_Id == 0 || driver.Driver_Id == null){
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: `Item ${x+1}: ` + self.$t('alert.require_driver_assign_driver'), life: 120000});
                                return;
                            }

                            if(driver.Vehicle_Id == 0 || driver.Vehicle_Id == null){
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: `Item ${x+1}: ` + self.$t('alert.require_vehicle_assign_driver'), life: 120000});
                                return;
                            }
                        }

                        if(!this.isCollective){
                            if(materials == null || (materials != null && materials.length == 0)){
                                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: `Item ${x+1}: ` + self.$t('alert.require_qty_assign_driver'), life: 120000});
                                    return;
                                }

                                var materialEmpty = materials.filter(function(item) {
                                    return  item.Qty <= 0;
                                });

                                if(materialEmpty.length == materials.length){
                                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: self.$t('alert.require_qty_assign_driver'), life: 120000});
                                    return;
                                }
                        }

                    }

                    this.blocked = true;
                    this.$axios.post(this.$API_URL + this.dataUrl + "assign_driver", data)
                        .then((response) => {
                            if (response.data.success) {
                                self.showAssignModal = false;
                                self.$parent.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                                self.$emit('close');
                            }
                            else {
                                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            }

                            self.blocked = false;
                            
                        })
                        .catch(function (err) {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                            self.blocked = false;
                            //self.showAssignModal = false;
                        });
                }
            },
            onShowAvailableShipmentsModal(){
                this.showAvailableShipmentsModal = true;

                this.getAvailableShipmentsList();
            },
            getAvailableShipmentsList(){
                var self = this;

                self.blocked = true;
                self.availableShipmentsLoading = true;
                self.availableShipmentsList = [];

                this.$axios.get(this.$API_URL + "list/available_shipments/" + this.data[0].Id)
                    .then((response) => {
                        if(response){
                            self.availableShipmentsList = response.data;
                        }
                        self.blocked = false;
                        self.availableShipmentsLoading = false;
                    })
                    .catch(function (err) {
                        self.$showToast({ severity: 'error', summary: "Error", detail: err, life: 120000});
                        self.blocked = false;
                        self.availableShipmentsLoading = true;
                        self.showAvailableShipmentsModal = false;
                    });
            },
            onAvailableShipmentSelect(event){
                var data = event.data;
                console.log(event);
                this.addToShipmentNo = data.Shipment_No;
                this.addToShipmentDriverName = data.Drivers[0].Driver_Name;
                this.addToShipmentLicenseNo = data.Drivers[0].License_No;
                this.addToShipmentVehicleNo = data.Drivers[0].Vehicle_Name;

                this.showAvailableShipmentsModal = false;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            selectedShipment(data){
                if(data.Shipment_No == this.addToShipmentNo){
                    return 'selected-transporter';
                }
                else return '';
            }      
            // addDetail() {
            //     var newDetail = this.driverModel;
            //     newDetail.mode = this.$FORM_MODE_CREATE;
            //     var det = { ...newDetail };

            //     this.driverModels.push(det);
            // },
            // deleteDetail(event) {
            //     if (event) {
            //         var detail = this.driverModels[event.index];

            //         if (detail.mode == this.$FORM_MODE_CREATE) this.driverModels.splice(this.driverModels.indexOf(detail), 1);
            //         else detail.mode = this.$FORM_MODE_DELETE;
            //     }
            // },
        },
        computed:{
            assignEditDriverModel(){
                return {driverModel: this.driverModel, driverModels: this.driverModels};
            }
        }


    }

</script>

